import React from 'react';
import classNames from 'classnames';

import { useIntl } from '../../util/reactIntl';

import css from './ListingFormChecklist.module.css';

/**
 * Live required-field checklist for a listing wizard step.
 *
 * @component
 * @param {Object} props
 * @param {Array<{ id: string, label: string, ok: boolean }>} props.items
 * @param {string} [props.title]
 */
const ListingFormChecklist = props => {
  const { className, rootClassName, items = [], title } = props;
  const intl = useIntl();
  const classes = classNames(rootClassName || css.root, className);
  const done = items.filter(i => i.ok).length;
  const total = items.length;
  const pct = total ? Math.round((done / total) * 100) : 0;

  if (!total) {
    return null;
  }

  return (
    <aside className={classes}>
      <div className={css.header}>
        <h3 className={css.title}>
          {title || intl.formatMessage({ id: 'ListingFormChecklist.title' })}
        </h3>
        <span className={css.count} aria-live="polite">
          {intl.formatMessage({ id: 'ListingFormChecklist.progress' }, { done, total })}
        </span>
      </div>
      <div className={css.barTrack} aria-hidden="true">
        <div className={css.barFill} style={{ width: `${pct}%` }} />
      </div>
      <ul className={css.list}>
        {items.map(item => (
          <li key={item.id} className={css.item}>
            <span className={classNames(css.dot, { [css.dotDone]: item.ok })} aria-hidden="true">
              ✓
            </span>
            <span className={classNames(css.label, { [css.labelDone]: item.ok })}>
              {item.label}
            </span>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default ListingFormChecklist;
